
(function() {
  var result = { translations: { "cs": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hod", "hoursAndMinutes": "{{ hours }} hod {{ minutes }} min", "days": "{{ days }} d", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "days": "{{ days }} d", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m" } }, "dateTime": { "quarterAndYear": "Q {{quarterNumber}}{{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, linka {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "cs": "static-7.980"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.980",
    "ar-eg": "static-7.980",
    "bg": "static-7.980",
    "bn": "static-7.980",
    "ca-es": "static-7.980",
    "cs": "static-7.980",
    "da": "static-7.980",
    "de": "static-7.980",
    "el": "static-7.980",
    "en-gb": "static-7.980",
    "en": "static-7.980",
    "es-mx": "static-7.980",
    "es": "static-7.980",
    "fi": "static-7.980",
    "fr-ca": "static-7.980",
    "fr": "static-7.980",
    "he-il": "static-7.980",
    "hr": "static-7.980",
    "hu": "static-7.980",
    "id": "static-7.980",
    "it": "static-7.980",
    "ja": "static-7.980",
    "ko": "static-7.980",
    "lt": "static-7.980",
    "ms": "static-7.980",
    "nl": "static-7.980",
    "no": "static-7.980",
    "pl": "static-7.980",
    "pt-br": "static-7.980",
    "pt-pt": "static-7.980",
    "ro": "static-7.980",
    "ru": "static-7.980",
    "sk": "static-7.980",
    "sl": "static-7.980",
    "sv": "static-7.980",
    "th": "static-7.980",
    "tl": "static-7.980",
    "tr": "static-7.980",
    "uk": "static-7.980",
    "vi": "static-7.980",
    "x-pseudo": "static-7.980",
    "zh-cn": "static-7.980",
    "zh-hk": "static-7.980",
    "zh-tw": "static-7.980"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:cs', {version: 'static-7.980'}); }
})();


